import React from 'react'
import {
  LeaseApplicationState,
  LeaseApplicationStatus,
  LeaseApplicationStep
} from '../../types/app-types'
import classNames from 'classnames'

interface ApplicationStepsProps {
  applicationState: LeaseApplicationState
}

export const applicationFormStep = {
  id: 1,
  label: 'Application Form',
  complete: false
}

export const applicationFeeStep = {
  id: 2,
  label: 'Application Fee',
  complete: false
}

export const backgroundCheckStep = {
  id: 3,
  label: 'Screening',
  complete: false
}

export const leaseApplicationSteps: LeaseApplicationStep[] = [
  applicationFormStep,
  applicationFeeStep,
  backgroundCheckStep
]

export function getCurrentStep(
  currentStatus: LeaseApplicationStatus
): LeaseApplicationStep {
  switch (currentStatus) {
    case LeaseApplicationStatus.FormInProgress:
      return applicationFormStep
    case LeaseApplicationStatus.FormCompleted:
    case LeaseApplicationStatus.PaymentInProgress:
    case LeaseApplicationStatus.PaymentFailed:
      return applicationFeeStep
    case LeaseApplicationStatus.PaymentCompleted:
    case LeaseApplicationStatus.BackgroundCheckInProgress:
    case LeaseApplicationStatus.BackgroundCheckCompleted:
    case LeaseApplicationStatus.LeaseRejected:
    case LeaseApplicationStatus.LeaseApproved:
      return backgroundCheckStep
    default:
      return applicationFormStep
  }
}

const ApplicationSteps = ({applicationState}: ApplicationStepsProps) => {
  const {currentStep, steps} = applicationState

  return (
    <ul className="steps my-4 w-full">
      {steps.map(step => {
        const isActive = step === currentStep
        return (
          <li
            key={step.id}
            className={classNames({
              'step': true,
              'step-primary': isActive || step.complete
            })}
          >
            {step.label}
          </li>
        )
      })}
    </ul>
  )
}

export default ApplicationSteps
